import React, { useState, useEffect } from 'react';
import Bg from "../assets/cta-bg.png"
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const Cta = () => {
    const { t } = useTranslation();
    const [ios, setIos] = useState(null);
    const [android, setAndroid] = useState(null);

    const getApps = () => {
        const url = (window.location.origin.includes("localhost") || window.location.origin.includes("test")) ? "https://paragon.testmedici.com" : window.location.origin;
        axios.get(`${url}/api/Global/Apps`)
            .then(response => {
                setIos(response.data.ios);
                setAndroid(response.data.android);
            })
            .catch(error => {
                console.error('Hata:', error);
            });
    }

    useEffect(() => {
        getApps();
    }, [])

    return (
        <div className='cta-content position-relative'>
            <div className="container position-relative" style={{ zIndex: 2 }}>
                <div className="row">
                    <div className="col-lg-7">
                        <h3 className='mb-3'>
                            {t('Yatırımınızı Hızla Başlatın, Paragon ile Kazançlı Bir Gelecek Yaratın!')}
                        </h3>
                        <div className='d-flex align-items-center mt-5 cta-market-items'>
                            <div className='cta-market-item'>
                                <a href={ios} target='_blank'>
                                    <img src="https://templatekit.jegtheme.com/digipay/wp-content/uploads/sites/385/2023/06/Mobile-app-store-badge-2.png" alt="" width="150px" />
                                </a>
                            </div>
                            <div className='cta-market-item ms-lg-4 ms-3'>
                                <a href={android} target='_blank'>
                                    <img src="https://templatekit.jegtheme.com/digipay/wp-content/uploads/sites/385/2023/06/Mobile-play-store-badge-2.png" alt="" width="175px" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="background-image">
                <img
                    src={Bg}
                    alt=""
                />
            </div>
        </div>
    );
};

export default Cta;
